import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

import { DateMarshaller } from 'app/constants/schemas/Date';
import { StaffProfile, IStaffProfile } from 'app/constants/schemas/StaffProfile';
import { IssueComment, IIssueComment } from './IssueComment';
import { IssueStatus, IssueStatusMarshaller } from 'app/constants/enums/IssueStatus';

export interface IIssue extends IEntity {
  attributes: {
    id: EntityStringId;
    issueStatus: IssueStatus;
    message: string | null;
    publishedLessonId: EntityStringId | null;
    createdAt: Date;
    updatedAt: Date;
  };
  associations: {
    creator: IStaffProfile | null;
    issueComments: IIssueComment[];
  };
}

export type Issue = Entity<IIssue>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Issue: IEntityType<IIssue> = vmClient.defineClass({
  typeName: 'Issue',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    issueStatus: {
      type: IssueStatus,
      marshaller: IssueStatusMarshaller,
      notNull: true,
    },
    message: 'string',
    publishedLessonId: 'string',
    createdAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
  associations: {
    creator: {
      type: StaffProfile,
      shared: true,
    },
    issueComments: [IssueComment],
  },
});
